import ReactDOM from "react-dom/client";
import jsbridge from "@xpeng/js-bridge";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "normalize.css";
import "./index.less";
import App from "./index.tsx";
import { initial } from "../../utils/initial";

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5分钟
    },
  },
});

// 初始化
initial({ appName: "charge-vip" });

const callHandlerOrigin = jsbridge.callHandler;
jsbridge.callHandler = (method, params) => {
  console.log(`====== bridge callHandler start =====`);
  console.log(`method: ${method}`);
  console.log("params: ");
  console.log(params);
  return callHandlerOrigin
    .call(jsbridge, method, params)
    .then((res) => {
      console.log(`method: ${method}`);
      console.log("response: ");
      console.log(res);
      console.log(`====== bridge callHandler end ======`);
      return res;
    })
    .catch((err) => {
      console.log(`method: ${method}`);
      console.log("error: ");
      console.log(err);
      console.log(`====== bridge callHandler end ======`);
      throw err;
    });
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
